
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.552 11.803c-.452.316-.82.127-.82-.431V4.628c0-.554.374-.743.82-.432l4.632 3.23c.453.315.446.832 0 1.144l-4.632 3.233z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    